import type { IngAddress } from "@/types/woocommerce.types";
import type { ProductVariant } from "@/types/shared.types";

export const find_variant_by_id = ({
  variant_id,
}: {
  variant_id: number;
}): ProductVariant | null => {
  const variants_el = document.getElementById("variants-data");
  if (!variants_el || !variants_el.dataset.variants) {
    console.error("Product variants data not available");
    return null;
  }

  const product_variants: ProductVariant[] = JSON.parse(
    variants_el.dataset.variants || "[]",
  );

  if (!product_variants || product_variants.length === 0) {
    console.error("No product variants available");
    return null;
  }

  const matching_variant = product_variants.find(
    (item) => item.variant_id === variant_id,
  );

  if (!matching_variant) {
    console.error(`No variant found with variant_id: ${variant_id}`);
    return null;
  }

  return matching_variant;
};

export const collect_billing_data = ({
  form_data,
}: {
  form_data: FormData;
}): IngAddress | null => {
  if (!form_data) {
    console.error("Form data is required for billing data collection");
    return null;
  }

  const billing_data: IngAddress = {
    first_name: form_data.get("billing_first_name") as string,
    last_name: form_data.get("billing_last_name") as string,
    company: (form_data.get("billing_company") as string) || "",
    address_1: form_data.get("billing_address_1") as string,
    address_2: form_data.get("billing_address_2") as string,
    city: form_data.get("billing_city") as string,
    state: String(form_data.get("billing_state") || "").toUpperCase(),
    postcode: form_data.get("billing_postcode") as string,
    country: String(form_data.get("billing_country") || "").toUpperCase(),
    email: form_data.get("billing_email") as string,
    phone: form_data.get("billing_phone") as string,
  };

  return billing_data;
};
